// Fetch/fetchSubscription.jsx
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://localhost:7204';

// Helper function to get headers with auth token
const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
    };
};

// Helper function to handle API responses
const handleResponse = async (response) => {
    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || `HTTP error! status: ${response.status}`);
    }
    
    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
        return await response.json();
    }
    
    return null;
};

// Get building subscription status
export const getBuildingSubscription = async (buildingId) => {
    try {
        const response = await fetch(`${API_BASE_URL}/api/Subscription/building/${buildingId}`, {
            method: 'GET',
            headers: getAuthHeaders()
        });
        
        return await handleResponse(response);
    } catch (error) {
        throw error;
    }
};

// Check building access
export const checkBuildingAccess = async (buildingId) => {
    try {
        const response = await fetch(`${API_BASE_URL}/api/Subscription/check-access/${buildingId}`, {
            method: 'GET',
            headers: getAuthHeaders()
        });
        
        return await handleResponse(response);
    } catch (error) {
        throw error;
    }
};

// Get payment history (returns PaymentApps)
export const getPaymentHistory = async (buildingId) => {
    try {
        const response = await fetch(`${API_BASE_URL}/api/Subscription/payments/${buildingId}`, {
            method: 'GET',
            headers: getAuthHeaders()
        });
        
        return await handleResponse(response);
    } catch (error) {
        throw error;
    }
};

// Get building with subscription information
export const getBuildingWithSubscription = async (buildingId) => {
    try {
        const response = await fetch(`${API_BASE_URL}/api/Building/with-subscription/${buildingId}`, {
            method: 'GET',
            headers: getAuthHeaders()
        });
        
        return await handleResponse(response);
    } catch (error) {
        throw error;
    }
};

// Check building access through building controller
export const checkBuildingAccessDirect = async (buildingId) => {
    try {
        const response = await fetch(`${API_BASE_URL}/api/Building/check-access/${buildingId}`, {
            method: 'GET',
            headers: getAuthHeaders()
        });
        
        return await handleResponse(response);
    } catch (error) {
        throw error;
    }
};

// NEW: Process payment for subscription
export const processPayment = async (paymentRequest) => {
    try {
        
        // Validate payment request
        if (!paymentRequest.subscriptionId) {
            throw new Error('Subscription ID is required');
        }
        if (!paymentRequest.amount || paymentRequest.amount <= 0) {
            throw new Error('Valid amount is required');
        }
        if (!paymentRequest.paymentMethod) {
            throw new Error('Payment method is required');
        }
        if (!paymentRequest.nextPaymentDue) {
            throw new Error('Next payment due date is required');
        }

        const response = await fetch(`${API_BASE_URL}/api/Subscription/payment`, {
            method: 'POST',
            headers: getAuthHeaders(),
            body: JSON.stringify({
                subscriptionId: paymentRequest.subscriptionId,
                amount: paymentRequest.amount,
                paymentMethod: paymentRequest.paymentMethod,
                nextPaymentDue: paymentRequest.nextPaymentDue
            })
        });
        
        const result = await handleResponse(response);
        
        return result;
    } catch (error) {
        throw error;
    }
};

// NEW: Create subscription for new building
export const createSubscription = async (buildingId) => {
    try {
        const response = await fetch(`${API_BASE_URL}/api/Subscription/create`, {
            method: 'POST',
            headers: getAuthHeaders(),
            body: JSON.stringify({
                buildingId: buildingId
            })
        });
        
        return await handleResponse(response);
    } catch (error) {
        throw error;
    }
};

// NEW: Update subscription status
export const updateSubscriptionStatus = async (subscriptionId, status) => {
    try {
        const response = await fetch(`${API_BASE_URL}/api/Subscription/update-status`, {
            method: 'PUT',
            headers: getAuthHeaders(),
            body: JSON.stringify({
                subscriptionId: subscriptionId,
                status: status
            })
        });
        
        return await handleResponse(response);
    } catch (error) {
        throw error;
    }
};

// NEW: Get all subscriptions for admin dashboard
export const getAllSubscriptions = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/api/Subscription/all`, {
            method: 'GET',
            headers: getAuthHeaders()
        });
        
        return await handleResponse(response);
    } catch (error) {
        throw error;
    }
};